import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import styles from './inputWrapper.module.css';

import { CheckIcon, WarningIcon } from '../SvgIcons';

export interface inputWrapperProps {
  label?: string;
  id?: string;
  error?: string;
  errormessage?: string;
  customWrapperClass?: string;
  children: JSX.Element;
  showHint?: boolean;
  hintmessage?: string;
}

export const getErrorId = (id?: string) => (id ? `${id}-error` : undefined);
export const getHintId = (id?: string) => (id ? `${id}-hint` : undefined);

export const getFieldA11yProps = ({ id, error, showHint }: { id?: string; error?: unknown; showHint?: boolean }) => {
  const describedBy = [error ? getErrorId(id) : undefined, showHint ? getHintId(id) : undefined]
    .filter(Boolean)
    .join(' ');
  return {
    'aria-invalid': error ? true : undefined,
    'aria-describedby': describedBy || undefined,
  };
};

export const InputWrapper: FunctionComponent<inputWrapperProps> = (props) => {
  const { children, label, id, error, errormessage, customWrapperClass, showHint, hintmessage } = props;

  const customWrapperClassParsed: string = typeof customWrapperClass === 'string' ? customWrapperClass : '';

  const classes = classNames({
    [styles.wrapper]: true,
    [customWrapperClassParsed]: true,
  });
  return (
    <div className={classes}>
      {label && (
        <label className={styles.label} htmlFor={id}>
          {label}
        </label>
      )}
      <div className={styles.inputWrap}>
        {children}
        <CheckIcon />
        <WarningIcon />
      </div>
      {error && (
        <div id={getErrorId(id)} className={styles.errorMessage}>
          {errormessage}
        </div>
      )}
      {showHint && (
        <div id={getHintId(id)} className={styles.hintMessage}>
          {hintmessage}
        </div>
      )}
    </div>
  );
};
